import Vue from 'vue'
import Router from 'vue-router'
import resume from '@/pages/resume.vue'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/:key',
      name: 'resume',
      component: resume,
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js